export default {
  Application: {
    Name: "Game99",
    Copyright: {
      Corporation: "",
      Website: "http://www.mmmk8888.com",
    }
  }
};
